import { LoaderCircle, RefreshCw } from 'lucide-react';

import { t } from '../i18n';
import type { AnimeSubject } from '../types/bgm';
import { AnimeCard } from './anime-card';
import { Button } from './button';

export const LoadingWall = () => (
  <div className="wall-message">
    <LoaderCircle className="spin" />
  </div>
);

export const EmptyWall = ({ message = t('contentUnavailable') }: { message?: string }) => (
  <div className="wall-message">
    <span>{message}</span>
  </div>
);

export const RequestErrorWall = ({
  message = t('requestFailedRetryLater'),
  onRetry,
}: {
  message?: string;
  onRetry: () => void;
}) => (
  <div className="wall-message">
    <div className="request-error-content">
      <span>{message}</span>
      <Button onClick={onRetry}>
        <RefreshCw className="size-4!" />
        <span>{t('refresh')}</span>
      </Button>
    </div>
  </div>
);

export const AnimeWall = ({
  subjects,
  className = '',
  emptyMessage,
}: {
  subjects: AnimeSubject[];
  className?: string;
  emptyMessage?: string;
}) => (
  <div className={`anime-wall ${className}`.trim()}>
    {subjects.length ? (
      subjects.map((subject) => <AnimeCard subject={subject} key={subject.id} />)
    ) : (
      <EmptyWall message={emptyMessage} />
    )}
  </div>
);
